import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import orderConfig from "emun.order/order.config";

export default class BackorderLinesPromptController {
	constructor(options, utils) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
		$ctrl.orderConfig = orderConfig;
		$ctrl.utils = utils;
		$ctrl.order = Object.assign({}, options.model, options.order);
		$ctrl.mode = options.mode;
		$ctrl.title = options.title;
		$ctrl.reverseSort = false;
		$ctrl.orderByField = "position";
		$ctrl.title = $ctrl.mode === 'backorder' ? 'Backordered Lines' : 'Shippable Lines';
		if ($ctrl.mode === 'backorder') {
			//$ctrl.items = $ctrl.order.items.filter(l => l.status === 'Open' && l.product.unitsInStock <= 0);
			$ctrl.items = $ctrl.order.items.filter(l => l.qtyOpen > 0);
		} else {
			//$ctrl.items = $ctrl.order.items.filter(l => l.status === 'Open' && l.product.unitsInStock > 0);
			$ctrl.items = $ctrl.order.items.filter(l => l.qtyOpen > 0 && l.product.availableQty >= l.qtyOpen);
		}
	}
	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			productId: 'Item #',
			description: "Description",
			qtyOpen: "Qty",
			price: "Price",
			openExtendedTotal: "Total"
		};

		// format the data
		$ctrl.items.forEach((item) => {
			itemsFormatted.push({
				productId: item.productId.replace(/,/g, ''),
				description: item.description.replace(/,/g,''),
				qtyOpen: item.qtyOpen,
				price: item.price,
				openExtendedTotal: item.openExtendedTotal
			});
		});

		var fileTitle = $ctrl.title;
		$ctrl.utils.exportCSVFile(headers, itemsFormatted, fileTitle);
	}
}
